/* eslint-disable no-nested-ternary */
/* eslint-disable no-promise-executor-return */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Image, Button, Form, Modal, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownload,
  faTrashCan,
  faArrowUpRightFromSquare,
  faImage,
  faUpload,
} from '@fortawesome/free-solid-svg-icons'
import replace from '../images/svgicons/replace.svg'
import apiServices from '../services/apiServices'

function ImgCard({ setting }) {
  const { id = 'file', img } = setting
  const [show, setShow] = useState(false)
  const [showImg, setShowImg] = useState(img)
  const [mediaShow, setMediaShow] = useState(false)
  // const [isLoading, setIsLoading] = useState(false)
  const handleOpen = () => {
    setShow(true)
  }
  const handleClose = () => {
    setShow(false)
  }

  const mediaHandle = (value) => {
    setMediaShow(value)
  }

  // useEffect(() => {
  //   if (isLoading) {
  //     setTimeout(() => {
  //       setIsLoading(false)
  //     }, 1000)
  //   }
  // }, [isLoading])

  const [imgState, setimgState] = useState(false)
  const getImage = async (imgSrc) => {
    const src = typeof imgSrc === 'string' ? imgSrc : imgSrc[0]
    const res = await apiServices.data({
      path: src.replace('/api/', ''),
      method: 'get',
    })
    if (res === 'PENDING') {
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
      await delay(3000)
      getImage(imgSrc)
    } else {
      // setIsLoading(false)
      setimgState(true)
    }
  }

  useEffect(() => {
    if (!img || !img[0]) {
      setimgState(true)
      return
    }
    if (!img[0].includes('imagejob')) {
      setimgState(true)
      return
    }
    // setIsLoading(true)
    setimgState(false)
    getImage(img[0])
  }, [img])

  const updateImg = (newImg) => {
    setShowImg(newImg)
  }

  const regenerate = async (imgSrc) => {
    setShow(false)
    await apiServices.data({
      path:
        typeof imgSrc === 'string'
          ? imgSrc.replace('/api/', '')
          : imgSrc[0].replace('/api/', ''),
      method: 'put',
      data: {
        status: 'WAITING',
      },
    })
    setimgState(false)
    getImage(imgSrc)
    // setIsLoading(true)
  }

  const [uploading, setuploading] = useState(null)
  useEffect(() => {
    const uploadImg = async () => {
      const getArrayBuffer = (files) =>
        new Promise((resolve) => {
          const reader = new FileReader()
          reader.addEventListener('load', () => {
            resolve(reader.result)
          })
          reader.readAsArrayBuffer(files)
        })
      const files = []
      files.push(getArrayBuffer(uploading))

      const buffered = await Promise.all(files)
      const arrayed = buffered.map((buffer) => ({
        name: uploading.name,
        data: Array.from(new Uint8Array(buffer)),
      }))
      const res = await apiServices.data({
        path: `draft/image`,
        method: 'post',
        data: {
          files: JSON.stringify(arrayed),
        },
      })
      if (!res.error)
        await apiServices.data({
          path:
            typeof img === 'string'
              ? img.replace('/api/', '')
              : img[0].replace('/api/', ''),
          method: 'put',
          data: {
            src: `/api/draft/image/${res[0].name}`,
          },
        })
      setuploading(null)
    }
    if (uploading) uploadImg()
  }, [uploading])

  const handleDelete = async () => {
    await apiServices.data({
      path:
        typeof img === 'string'
          ? img.replace('/api/', '')
          : img[0].replace('/api/', ''),
      method: 'put',
      data: {
        src: '',
      },
    })
  }

  return (
    <>
      <div
        className="img-card h-100"
        onClick={handleOpen}
        onKeyDown={handleOpen}
        // role="button"
        // tabIndex={0}
        style={{
          minHeight: '150px',
        }}
        aria-hidden
      >
        {imgState && (
          <div className="img-mask">
            {/* {uploadBtn ? ( */}
            <Button
              variant="btn-dai text-light m-auto"
              title="上傳"
              onClick={(e) => {
                e.stopPropagation()
              }}
            >
              <Form.Label className="m-auto text-light" htmlFor={id}>
                <FontAwesomeIcon icon={faUpload} />
              </Form.Label>
            </Button>
            <Form.Control
              id={id}
              name="file"
              type="file"
              onChange={(e) => {
                setuploading(e.target.files[0])
                e.target.value = ''
                e.stopPropagation()
              }}
              onClick={(e) => {
                e.stopPropagation()
              }}
              className="p-0 m-0 border-0"
              style={{
                visibility: 'hidden',
                width: '0px',
                height: '0px',
              }}
            />
            {/* ) : (
            <Button
              variant="btn-dai text-light m-auto"
              title="取代"
              onClick={(e) => {
                setMediaShow(true)
                e.stopPropagation()
              }}
            >
              <img
                src="images/svgicons/replace.svg"
                alt=""
                style={{
                  height: '20px',
                }}
              />
            </Button>
          )} */}
            <Button
              variant="btn-dai text-light m-auto"
              title="重新生成"
              onClick={(e) => {
                // setMediaShow(true)
                regenerate(img)
                e.stopPropagation()
              }}
            >
              <img
                src={replace}
                alt=""
                style={{
                  height: '20px',
                }}
              />
            </Button>
            {/* <Button
            title="重新生成"
            variant="btn-dai"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              regenerate(img)
            }}
          >
            {img ? (
              <img
                src={typeof img === 'string' ? img : img[0]}
                alt=""
                style={{
                  filter: 'invert(100%)',
                  height: '20px',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <FontAwesomeIcon icon={faImage} />
            )}
          </Button> */}
            <Button
              variant="btn-dai text-light m-auto"
              title="刪除"
              onClick={(e) => {
                handleDelete()
                e.stopPropagation()
              }}
            >
              <FontAwesomeIcon icon={faTrashCan} />
            </Button>
          </div>
        )}
        {imgState ? (
          !img || !img[0] ? (
            <Card
              className="d-flex"
              style={{
                minHeight: '150px',
                height: '100%',
              }}
            >
              <FontAwesomeIcon className="m-auto w-25 h-25" icon={faImage} />
            </Card>
          ) : (
            <Image
              className="m-auto"
              style={{
                height: 'auto',
                // maxHeight,
                // minHeight: '200px',
                maxWidth: '100%',
              }}
              src={img}
              alt="圖片失效"
            />
          )
        ) : (
          <Card
            className="h-100 w-100 d-flex"
            style={{
              minHeight: '150px',
            }}
          >
            <Loading />
          </Card>
        )}
        {/* <Image src={img} alt="" className={isLoading ? 'opacity-0' : ''} /> */}
        {/* {isLoading && <Loading />} */}
      </div>
      <ImageModal setting={{ show, handleClose, img: showImg, regenerate }} />
      <MediaModal setting={{ mediaShow, mediaHandle, updateImg }} />
    </>
  )
}

function ImageModal({ setting }) {
  const { show, handleClose, img, regenerate } = setting
  return (
    <Modal
      size="xl"
      show={show !== false}
      onHide={() => handleClose(false)}
      className="warning-block img-modal"
      centered
    >
      <Image src={img} alt="" className="w-100" />
      <div className="d-flex justify-content-end">
        <Button
          title="重新生成"
          variant="btn-dai"
          href={img}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            regenerate(img)
          }}
        >
          <img src="/images/svgicons/generate.svg" alt="" className="icon" />
          重新生成
        </Button>
        <Button
          title="下載"
          variant="btn-dai"
          href={img}
          download
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          <FontAwesomeIcon icon={faDownload} />
          下載
        </Button>
        <Button
          title="另開視窗"
          variant="btn-dai"
          href={img}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation()
          }}
        >
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          另開視窗
        </Button>
      </div>
      <Button className="btn-text modal-close" onClick={() => handleClose()}>
        <div
          className="svgIcon"
          style={{
            maskImage: `url('/images/svgicons/close.svg')`,
          }}
        >
          close
        </div>
      </Button>
    </Modal>
  )
}

function MediaModal({ setting }) {
  const { mediaShow = false, mediaHandle, updateImg = () => {} } = setting

  return (
    <Modal
      size="fullscreen"
      show={mediaShow}
      onHide={() => mediaHandle(false)}
      className="media-modal"
      centered
    >
      <div className="mediaWrap d-flex flex-wrap">
        <h2 className="modal-title">素材庫</h2>
        <div className="flex-1">
          <div className="mediaHeader">
            <Form.Select aria-label="Default select example">
              <option>全部素材</option>
              <option value="1">素材一</option>
              <option value="2">素材二</option>
              <option value="3">素材三</option>
            </Form.Select>
            <Form.Label htmlFor="uploadfile" className="mb-0">
              <div className="btn btn-primary btn-md">
                <div
                  className="svgIcon"
                  style={{
                    maskImage: `url('/images/svgicons/add.svg')`,
                    transform: 'translateY(1px)',
                    marginRight: '10px',
                  }}
                >
                  icon
                </div>
                上傳素材
              </div>
            </Form.Label>
            <Form.Control
              id="uploadfile"
              name="uploadfile"
              type="file"
              onChange={() => {}}
            />
            <hr className="w-100" />
          </div>
          <div className="mediaList">
            <div className="media-item">
              <img
                src="https://picsum.photos/1920/1080?random=1"
                className="w-100"
                alt=""
              />
              <Button
                onClick={() => {
                  mediaHandle(false)
                  updateImg('https://picsum.photos/1920/1080?random=1')
                }}
              >
                選擇圖片
              </Button>
            </div>
            <div className="media-item">
              <img
                src="https://picsum.photos/1152/1152?random=2"
                className="w-100"
                alt=""
              />
              <Button
                onClick={() => {
                  mediaHandle(false)
                  updateImg('https://picsum.photos/1152/1152?random=2')
                }}
              >
                選擇圖片
              </Button>
            </div>
            <div className="media-item">
              <img
                src="https://picsum.photos/1152/1152?random=3"
                className="w-100"
                alt=""
              />
              <Button
                onClick={() => {
                  mediaHandle(false)
                  updateImg('https://picsum.photos/1920/1080?random=3')
                }}
              >
                選擇圖片
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Button
        className="btn-text modal-close"
        onClick={() => mediaHandle(false)}
      >
        <div
          className="svgIcon"
          style={{
            maskImage: `url('/images/svgicons/close.svg')`,
          }}
        >
          close
        </div>
      </Button>
    </Modal>
  )
}

// function Loading() {
//   return (
//     <div className="loading-wrap">
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar mb-4">loading</div>
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar mb-4">loading</div>
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar mb-4">loading</div>
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar mb-2">loading</div>
//       <div className="loading-bar">loading</div>
//     </div>
//   )
// }
function Loading() {
  return (
    <div className="img-loading">
      <img src="/images/image-loading.svg" alt="" />
    </div>
  )
}

ImgCard.propTypes = {
  setting: PropTypes.shape().isRequired,
}

ImageModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

MediaModal.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default ImgCard
